"use strict";
exports.__esModule = true;
/**
 * Used to configure quiz
 * @param title Site title
 * @default process.env.NEXT_PUBLIC_SITE_TITLE
 * @param instructor Instructor name
 * @default process.env.NEXT_PUBLIC_PARTNER_FIRST_NAME
 * @param answerSubmitUrl API route for submitting user answer
 * @default process.env.NEXT_PUBLIC_CONVERTKIT_ANSWER_URL || '/api/answer'
 * @param questionBodyRenderer e.g. PortableText
 * @default ReactMarkdown
 */
function getConfig(_a) {
    var _b = _a.title, title = _b === void 0 ? process.env.NEXT_PUBLIC_SITE_TITLE : _b, _c = _a.instructor, instructor = _c === void 0 ? process.env.NEXT_PUBLIC_PARTNER_FIRST_NAME : _c, _d = _a.answerSubmitUrl, answerSubmitUrl = _d === void 0 ? process.env.NEXT_PUBLIC_CONVERTKIT_ANSWER_URL ||
        '/api/answer' : _d, questionBodyRenderer = _a.questionBodyRenderer, _e = _a.afterCompletionMessages, afterCompletionMessages = _e === void 0 ? {
        neutral: {
            "default": "Thanks for submitting your answer!\n\nI'll send the next lesson in 5-10 minutes. Check your inbox.\n\n_Thanks,_\n_".concat(instructor, "_"),
            last: "Thanks for submitting your answer!\n\nThis was the last lesson from the ".concat(title, " email course. We hope you learned something new, and we look forward to sharing more in the future!\n\n_Thanks,_\n_").concat(instructor, "_")
        },
        correct: {
            "default": "Nice work. You chose the correct answer!\n\nI'll send the next lesson in 5-10 minutes. Check your inbox.\n\n_Thanks,_\n_".concat(instructor, "_"),
            last: "Nice work. You chose the correct answer!\n\nThis was the last lesson from the ".concat(title, " email course. We hope you learned something new, and I look forward to sharing more in the future!\n\n_Thanks,_\n_").concat(instructor, "_")
        },
        incorrect: {
            "default": "You chose an incorrect answer, but don't worry. Just go back and re-read the email and check out any linked resources. You can refresh the page if you'd like to try again! \uD83D\uDC4D\n\nI'll send the next email in 5-10 minutes too so you can learn more.\n\n_Thanks,_\n_".concat(instructor, "_"),
            last: "You chose an incorrect answer, but don't worry. Just go back and re-read the email and check out any linked resources. You can refresh the page if you'd like to try again! \uD83D\uDC4D\n\nThis was the last lesson from the ".concat(title, " email course. We hope you learned something new, and I look forward to sharing more in the future!\n\n_Thanks,_\n_").concat(instructor, "_")
        }
    } : _e;
    return {
        answerSubmitUrl: answerSubmitUrl,
        afterCompletionMessages: afterCompletionMessages,
        questionBodyRenderer: questionBodyRenderer
    };
}
exports["default"] = getConfig;
